import React from 'react';
import {useTranslation} from 'react-i18next';
import {getFixtureDisplay} from "@/utils/formatters.js";
import TeamDisplay from "@/components/TeamDisplay.jsx";
import {FIXTURE_STATE_CONFIG} from "@/utils/constants.js";
import i18n from "i18next";

export const MatchCard = ({fixture, matchScore, isGoalFlashing, onTeamClick}) => {

    const {t} = useTranslation();

    if (!fixture || !fixture?.type) return;

    const stateDisplay = getFixtureDisplay(fixture.type, fixture.state, fixture.minutes, fixture.extraMinutes, t);

    const formatMatchDate = (dateString) => {
        if (!dateString) return '';
        const utcDateString = dateString.endsWith('Z') ? dateString : `${dateString}Z`;

        const date = new Date(utcDateString);

        return new Intl.DateTimeFormat(i18n.language, {
            day: 'numeric',
            month: 'short',
            hour: '2-digit',
            minute: '2-digit'
        }).format(date)
            .replace(',', ' •')
            .replace('.', '');
    };

    return (
        <div
            className="bg-white rounded-3xl p-5 shadow-[0_10px_25px_-5px_rgba(0,0,0,0.1)] border border-gray-50 -mt-10 relative z-20 transition-all">
            <div className="flex justify-between items-center border-b border-gray-100 pb-3 mb-3">
                <div className="flex items-center gap-2">
                    {stateDisplay.isLive && (
                        <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse"></span>
                    )}
                    <span className={`text-xs font-bold uppercase px-2 py-0.5 rounded ${stateDisplay.color}`}>
                                {stateDisplay.label}
                            </span>

                    {fixture.state === FIXTURE_STATE_CONFIG.NOT_STARTED && fixture.startingAt && (
                        <>
                            {/* Séparateur discret */}
                            <span className="text-gray-300 text-[10px]">|</span>

                            {/* Date et Heure */}
                            <span className="text-[11px] font-semibold text-gray-400 uppercase tracking-wide">
                                {formatMatchDate(fixture.startingAt)}
                            </span>
                        </>
                    )}
                </div>
                <div className="flex items-center gap-2">
                    {fixture.league.logoUrl && (
                        <img src={fixture.league.logoUrl} className="w-4 h-4 object-contain" alt="League"/>
                    )}
                    <span className="text-xs font-medium text-gray-400">{fixture.label}</span>
                </div>
            </div>

            {/* TEAMS & SCORE */}
            <div className="flex justify-between items-center">
                <TeamDisplay
                    team={fixture.homeTeam}
                    onClick={onTeamClick ? () => onTeamClick('HOME') : undefined}
                />
                <div className="flex flex-col items-center w-1/3">
                    {fixture.state === FIXTURE_STATE_CONFIG.NOT_STARTED ? (
                        <div className="text-3xl font-black text-gray-300 tracking-tighter">VS</div>
                    ) : (
                        <div
                            className={`text-3xl font-black tracking-tighter transition-all duration-300 ${isGoalFlashing ? 'text-score-neon animate-flash-goal' : 'text-score-neon'}`}>
                            {matchScore.team1 ?? 0} - {matchScore.team2 ?? 0}
                        </div>
                    )}
                </div>
                <TeamDisplay
                    team={fixture.awayTeam}
                    onClick={onTeamClick ? () => onTeamClick('AWAY') : undefined}
                />
            </div>
        </div>)
};